import { GetterTree } from 'vuex';
import { Locale } from 'platform-unit2-api/locales';
import { LocaleState } from '../locales.types';

export const getters: GetterTree<LocaleState, {}> = {
  currentLocale(state: LocaleState): Locale | undefined {
    return state.selectedLocale;
  },
};
